import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { InactivityModalComponent } from './components/inactivity-modal/inactivity-modal.component';
import { IosHelpersService } from './service/ios/ios-helpers.service';
import { ModuleLoadingErrorService } from './service/components/module-loading-error.service';
import { CacheBustingService } from './service/components/cache-busting.service';

/**
 * Componente principal de la aplicación
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    ToastContainerComponent,
    SpinnerComponent,
    InactivityModalComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'autenicworkshop';

  constructor(
    private iosHelpers: IosHelpersService,
    private moduleLoadingErrorService: ModuleLoadingErrorService,
    private cacheBustingService: CacheBustingService
  ) {}

  ngOnInit(): void {
    // El servicio IosHelpersService se inicializa automáticamente
    // y aplica las correcciones necesarias para iOS si es necesario
    // El servicio ModuleLoadingErrorService se inicializa automáticamente
    // y configurará los manejadores de errores de carga de módulos
    // El servicio CacheBustingService se inicializa automáticamente
    // y configurará la detección y limpieza de caché obsoleto
  }
}
